import { actions } from "./actions";
import { initialState } from "./constants";
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_OFFICE_BRANCHES_REQUEST:
      return {
        ...state,
        getOfficeBranches: {
          loading: true,
          success: false,
          error: false,
          data: null,
        },
      };
    case actions.GET_OFFICE_BRANCHES_SUCCESS:
      return {
        ...state,
        getOfficeBranches: {
          loading: false,
          success: true,
          error: false,
          data: action.payload,
        },
      };
    case actions.GET_OFFICE_BRANCHES_FAILURE:
      return {
        ...state,
        getOfficeBranches: {
          loading: false,
          success: false,
          error: true,
          data: null,
        },
      };
    default:
      return state;
  }
};
export { reducer, actions, initialState };
